// extracted by mini-css-extract-plugin
export default {"payrollOverview-header":"Header_payrollOverview-header__1QyI5","payrollOverview-header-item":"Header_payrollOverview-header-item__sjOyR"};